// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityWaypointCategoryFilters_container__8nu2Q","row":"CommunityWaypointCategoryFilters_row__kbSEl","label":"CommunityWaypointCategoryFilters_label__q0wAw"};